import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const fromParallel = (type, generator) => {
    return new BasicParallelEnumerable({
        generator,
        type,
    });
};
